import { fetchData } from '../utils/netUtils';

// Verificar que window.__TBX_ENV__ existe y tiene la estructura esperada
const getTBXEnv = () => {
  if (typeof window !== 'undefined' && window.__TBX_ENV__) {
    return window.__TBX_ENV__;
  }
  // Valores por defecto para desarrollo
  return {
    pass: {
      baseURL: 'https://api.example.com' // URL por defecto para desarrollo
    }
  };
};

const { pass } = getTBXEnv();

class CloudpassService {
  apiURL: string;
  cpShortName: string;

  /**
   * constructor to pay service instance
   * @param clientShortName - Cloudpass client shortName to use
   */
  constructor(cpShortName: string) {
    this.apiURL = pass.baseURL;
    this.cpShortName = cpShortName;
  }

  getTADLoginStatus() {
    const URL = `${this.apiURL}/auth/${this.cpShortName}/status.json`;
    const options = {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8'
      },
    };
    return fetchData(URL, options, 3, 300);
  }

  getMsoURL() {
    const URL = `${this.apiURL}/auth/${this.cpShortName}/mso.json`;
    return URL;
  }

  logout() {
    const URL = `${this.apiURL}/auth/${this.cpShortName}/logout.json`;
    const options = {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8'
      },
    };
    return fetchData(URL, options, 3, 300);
  }

  getOauth2LoginURL({
    countryCode,
    idpShortName,
    redirectURL
  }: {
    countryCode?: string,
    idpShortName: string,
    redirectURL: string
  }) {

    let URL = `${this.apiURL}/auth/authorize?client_id=${this.cpShortName}&idp=${idpShortName}&redirect_uri=${redirectURL}&response_type=code`;

    if (countryCode) URL += `&country=${countryCode}`;


    return URL;
  }
}

export default CloudpassService;
